var React = require('react');

function IconSmartTime (props) {
    return React.createElement("svg",props,React.createElement("path",{"data-name":"Path 422","d":"M250 0C112.105 0 0 112.105 0 250s112.105 250 250 250 250-112.105 250-250S387.895 0 250 0zm98.421 318.947a24.033 24.033 0 01-20 10.526 27.9 27.9 0 01-14.211-4.211L235.789 270c-6.316-4.737-10.526-12.105-10.526-20V117.895a24.737 24.737 0 0149.474 0v119.473l67.895 47.895c11.052 7.369 13.684 22.632 5.789 33.684z","fill":"#10457a"}));
}

IconSmartTime.defaultProps = {"width":"500","height":"500","viewBox":"0 0 500 500"};

module.exports = IconSmartTime;

IconSmartTime.default = IconSmartTime;
